import ApiBase from './api-base'
import { ACTIVE_BASE_REST } from './constants'
export default class CalendarTraffic extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/calendar/trafficPlan'
    super(store, path)
  }
}
